exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mySuggestions__container {\n    font-size: .725rem;\n    font-family: Montserrat;\n    color: #212529;\n    font-weight: 500;\n}\n\n.mySuggestions__ContainerOpen {\n    border: 1px solid #eee;\n    background-color: #fff;\n    max-height: 150px;\n    overflow: auto;\n}\n\n.mySuggestions__suggestion {\n    padding: 5px 10px;\n    border-bottom: 1px solid #eee;\n}\n\n.mySuggestions__suggestionHighlighted {\n    background: #1a7fb3;\n    color: #fff;\n}", ""]);

// exports
